import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from "Contexts/app-context";
import { TranslationProvider } from "Contexts/translation-context";
import App from "./app";
import "./index.css";
import { BrandProvider } from "Contexts/brand-context";

/* There might be some better way to do this */
const preloadFonts = () => (
  <span style={{ visibility: "hidden", maxHeight: "0" }}>
    <span style={{ fontWeight: 100 }} />
    <span style={{ fontWeight: 200 }} />
    <span style={{ fontWeight: 300 }} />
    <span style={{ fontWeight: 400 }} />
    <span style={{ fontWeight: 500 }} />
    <span style={{ fontWeight: 600 }} />
    <span style={{ fontWeight: 700 }} />
    <span style={{ fontWeight: 800 }} />
    <span style={{ fontWeight: 900 }} />
  </span>
);

render(
  <Router>
    <AppProvider>
      <BrandProvider>
        <TranslationProvider>
          <App />
        </TranslationProvider>
      </BrandProvider>
    </AppProvider>
    {preloadFonts()}
  </Router>,
  document.getElementById("app")
);
